/**
 * Compact filter bar — source, activity, status, type. All filters sync with parent state.
 */
import React from 'react';
import ActivitySelector from './ActivitySelector';

const SOURCE_OPTIONS = [
  { value: 'all', label: 'All Sources' },
  { value: 'calendar', label: 'CMS Calendar' },
  { value: 'memo', label: 'Memo' },
  { value: 'cap', label: 'CAP' },
];

/** Friendly names for the program filter; anything unlisted shows as stored. */
const PROGRAM_LABELS = {
  'CMS': 'Medicare (CMS)',
  'State Medicaid (SMAC)': 'Medicaid (SMAC)',
};

export default function FilterBar({
  sourceFilter,
  setSourceFilter,
  showSource = true,
  activityFilter,
  setActivityFilter,
  activities = [],
  statusFilter,
  setStatusFilter,
  typeFilter,
  setTypeFilter,
  obligationTypes = [],
  onClearFilters,
  DUE_SOON_DAYS = 14,
  hasActiveFilters = false,
}) {
  return (
    <div className="flex flex-wrap items-center gap-3 py-3 px-4 bg-slate-50/80 rounded-xl border border-slate-200/80">
      <div className="flex items-center gap-2">
        <span className="text-xs font-semibold uppercase tracking-wider text-slate-500">Filters</span>
      </div>
      {showSource && (
      <select
        value={sourceFilter}
        onChange={(e) => setSourceFilter(e.target.value)}
        className="bg-white border border-slate-200 text-slate-700 rounded-lg px-3 py-2 text-sm font-medium focus:outline-none focus:ring-2 focus:ring-indigo-500/30 focus:border-indigo-400 min-w-[130px]"
        aria-label="Filter by source"
      >
        {SOURCE_OPTIONS.map((opt) => (
          <option key={opt.value} value={opt.value}>{opt.label}</option>
        ))}
      </select>
      )}
      <ActivitySelector
        activities={activities}
        value={activityFilter}
        onChange={setActivityFilter}
        placeholder="All activities"
        className="min-w-[200px]"
      />
      <select
        value={statusFilter}
        onChange={(e) => setStatusFilter(e.target.value)}
        className="bg-white border border-slate-200 text-slate-700 rounded-lg px-3 py-2 text-sm font-medium focus:outline-none focus:ring-2 focus:ring-indigo-500/30 focus:border-indigo-400 min-w-[140px]"
        aria-label="Filter by status"
      >
        <option value="all">All statuses</option>
        <option value="overdue">Overdue</option>
        <option value="due_soon">Due in {DUE_SOON_DAYS} days</option>
        <option value="upcoming">Upcoming</option>
        <option value="in_progress">In progress</option>
        <option value="completed">Completed</option>
        <option value="no_action_needed">No action needed</option>
      </select>
      <select
        value={typeFilter}
        onChange={(e) => setTypeFilter(e.target.value)}
        className="bg-white border border-slate-200 text-slate-700 rounded-lg px-3 py-2 text-sm font-medium focus:outline-none focus:ring-2 focus:ring-indigo-500/30 focus:border-indigo-400 min-w-[120px]"
        aria-label="Filter by program"
      >
        <option value="all">All programs</option>
        {obligationTypes.map((type) => (
          <option key={type} value={type}>{PROGRAM_LABELS[type] || type}</option>
        ))}
      </select>
      {hasActiveFilters && (
        <button
          type="button"
          onClick={onClearFilters}
          className="text-sm font-medium text-slate-500 hover:text-slate-700"
        >
          Clear filters
        </button>
      )}
    </div>
  );
}
